import { recordPath, recordRoute } from '@/shared/registry'

/** Where the learning path pages live. */
export const learningPathsPath = '/catalog/learning-paths'
export const createLearningPathPath = `${learningPathsPath}/new`
export const learningPathRoute = recordRoute('catalog', 'learning-paths')
export const editLearningPathRoute = `${learningPathRoute}/edit`

/** A learning path's details page. */
export function learningPathPath(id: string): string {
  return recordPath('catalog', 'learning-paths', id)
}

/** The base of Learning Path Details' slots (`detailsSlots`). */
export const learningPathDetailsSlot = 'catalog.learning-path-details'

/** The API's learning path endpoints. */
export const learningPathsApi = '/catalog/v1/learning-paths'

export function learningPathApi(id: string): string {
  return `${learningPathsApi}/${encodeURIComponent(id)}`
}

/** Where a path's courses are set, all at once and in order. */
export function learningPathCoursesApi(id: string): string {
  return `${learningPathApi(id)}/courses`
}

/** What each learning path action needs. */
export const readLearningPathsPermission = 'catalog.learning-paths.read'
export const writeLearningPathsPermission = 'catalog.learning-paths.write'
export const deleteLearningPathsPermission = 'catalog.learning-paths.delete'
